import { render, staticRenderFns } from "./EditLabelsModal.vue?vue&type=template&id=afcc915c&"
import script from "./EditLabelsModal.vue?vue&type=script&lang=js&"
export * from "./EditLabelsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports